import { createSession } from './session';
import { DEFAULT_SESSION_EXPIRATION, EXTENDED_SESSION_EXPIRATION } from '@/shared/lib/auth-config.ts';
import type { AuthenticationResult } from '../model/types';

export async function signInWithCredentials(
  email: string,
  password: string,
  keepSignedIn = false,
): Promise<AuthenticationResult> {
  try {
    const expiration = keepSignedIn ? EXTENDED_SESSION_EXPIRATION : DEFAULT_SESSION_EXPIRATION;
    const sessionResponse = await createSession(email, password, expiration);

    if (sessionResponse.success && sessionResponse.data?.session_id) {
      return {
        success: true,
        sessionId: sessionResponse.data.session_id
      };
    } else {
      return {
        success: false,
        error: sessionResponse.error || 'Session creation failed',
        validationError: sessionResponse.validationError,
      };
    }
  } catch (error) {
    return {
      success: false,
      error: error instanceof Error ? error.message : 'Unknown authentication error'
    };
  }
}
